import i18n from '@/i18n'
import FormValidationRules from '@/components/shared/forms/FormValidationRules'

const ADDRESS_XSS_FIELD = /^[^<>"/]*$/
const QUOTED_XSS_FIELD = /^[^<>/]*$/

const PhysicalDeliveryFormSchema = {
  fluid: true,
  fields: [
    {
      type: 'v-text-field',
      model: 'firstName',
      props: {
        id: 'checkout-physical-first-name',
        name: 'checkout-physical-first-name',
        label: i18n.t('checkout-recipient-first-name'),
        outlined: true,
        'aria-label': i18n.t('checkout-recipient-first-name'),
        'aria-invalid': 'false',
        rules: [
          FormValidationRules.required(
            i18n.t('checkout-recipient-first-name-valid')
          ),
          FormValidationRules.regex(
            QUOTED_XSS_FIELD,
            i18n.t('shippingAddress.validation.nameXss')
          )
        ]
      },
      responsive: {
        md: 6
      }
    },
    {
      type: 'v-text-field',
      model: 'lastName',
      props: {
        id: 'checkout-physical-last-name',
        name: 'checkout-physical-last-name',
        label: i18n.t('checkout-recipient-last-name'),
        outlined: true,
        'aria-label': i18n.t('checkout-recipient-last-name'),
        'aria-invalid': 'false',
        rules: [
          FormValidationRules.required(
            i18n.t('checkout-recipient-last-name-valid')
          ),
          FormValidationRules.regex(
            QUOTED_XSS_FIELD,
            i18n.t('shippingAddress.validation.nameXss')
          )
        ]
      },
      responsive: {
        md: 6
      }
    },
    {
      type: 'slot',
      model: 'streetLine1',
      rules: [
        FormValidationRules.required(
          i18n.t('shippingAddress.streetLine1.validationMessage')
        ),
        FormValidationRules.regex(
          ADDRESS_XSS_FIELD,
          i18n.t('shippingAddress.validation.addressXss')
        )
      ]
    },
    {
      type: 'v-text-field',
      model: 'streetLine2',
      props: {
        id: 'checkout-physical-streetLine2',
        name: 'checkout-physical-streetLine2',
        label: i18n.t('shippingAddress.streetLine2.label'),
        outlined: true,
        'aria-label': i18n.t('shippingAddress.streetLine2.label'),
        'aria-invalid': 'false',
        rules: [
          FormValidationRules.regex(
            ADDRESS_XSS_FIELD,
            i18n.t('shippingAddress.validation.nameXss')
          )
        ]
      }
    },
    {
      type: 'v-text-field',
      model: 'city',
      props: {
        id: 'checkout-physical-city',
        name: 'checkout-physical-city',
        label: i18n.t('shippingAddress.city.label'),
        outlined: true,
        'aria-label': i18n.t('shippingAddress.city.label'),
        'aria-invalid': 'false',
        rules: [
          FormValidationRules.required(
            i18n.t('shippingAddress.city.validationMessage')
          ),
          FormValidationRules.regex(
            ADDRESS_XSS_FIELD,
            i18n.t('shippingAddress.validation.nameXss')
          )
        ]
      },
      responsive: {
        md: 6
      }
    },
    {
      type: 'slot',
      model: 'stateOrProvince',
      responsive: {
        md: 6
      }
    },
    {
      type: 'v-text-field',
      model: 'postalCode',
      props: {
        id: 'checkout-physical-postal-code',
        name: 'checkout-physical-postal-code',
        label: i18n.t('shippingAddress.postalCode.label'),
        outlined: true,
        'aria-label': i18n.t('shippingAddress.postalCode.label'),
        'aria-invalid': 'false',
        rules: [
          FormValidationRules.required(
            i18n.t('shippingAddress.postalCode.validationMessage')
          ),
          FormValidationRules.regex(
            ADDRESS_XSS_FIELD,
            i18n.t('shippingAddress.validation.nameXss')
          )
        ]
      },
      responsive: {
        md: 6
      }
    }
  ]
}

export default PhysicalDeliveryFormSchema
